export class ConnectionError extends Error {
  code: string;

  constructor() {
    super('Connection Error');
    this.code = 'E_CONNECTION_ERROR';
  }
}
